$shm_hitalama_map_widget_float_text_md $shm_hitalama_map_widget_float
	controls /
		<= Md $mol_text
			text <= text \
